import React from 'react'

const SiniestrosLaborales = ({iconContactoMasculino}) => {
   return (
      <>
         <div className="bg-latitud animated fadeIn" style={{"margin-bottom":"30px"}}>
            <div className="container section center white-text">
               <h5>
                  <strong>Siniestros Laborales</strong>
               </h5>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>EMERGENCIAS MÉDICAS</strong><br/>
                        0388 - 156 867 840
                     </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>DENUNCIAS DE ACCIDENTES</strong><br/>
                           0-800-199-0022
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>CONSULTAS GENERALES</strong><br/>
                           0388 - 4911741 Int.: 119<br/>
                           atapia@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default SiniestrosLaborales